import { Capacitor } from '@capacitor/core';
import { CapacitorUpdater } from '@capgo/capacitor-updater';

// Mises à jour OTA (Capgo) — app native uniquement.
//
// `notifyAppReady()` est OBLIGATOIRE : sans lui, le plugin considère le nouveau
// bundle comme invalide et effectue un rollback vers la version précédente.
//
// La livraison des bundles (autoUpdate / download manuel) sera activée dès que
// le serveur Capgo (self-hosted) sera configuré (`updateUrl` dans
// capacitor.config.ts).

export async function initOTA(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;
  try {
    await CapacitorUpdater.notifyAppReady();
  } catch (e) {
    console.warn('[ota] notifyAppReady failed', e);
  }
}
